import React, { useEffect, useState } from 'react'
import { useHistory, Route, useRouteMatch } from 'react-router-dom'

/* MUI */
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Dialog, Button, CircularProgress, Divider, Drawer, Typography, Box, Stack, IconButton, AppBar, Toolbar } from '@mui/material'
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import GroupIcon from '@mui/icons-material/Group';
import PaymentIcon from '@mui/icons-material/Payment';
import BookIcon from '@mui/icons-material/Book';
import LogoutIcon from '@mui/icons-material/Logout';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { Assessment, MoreVert, PowerSettingsNew, QuestionAnswer } from '@mui/icons-material';

export default function SidebarAdmin(){
    let history = useHistory()
    const api = '/instituteapi/admin/index.php'
    const { path, url } = useRouteMatch()
    
    useEffect(() => {
        fetch('/instituteapi/admin/ui.php')
        .then(res => res.json())
        .then(data => {
            if(data.loggedin === false){
                history.replace('/login-admin')
            }
        })
    }, [])

    const links = [
        {name: 'Dashboard', link: '/dashboard-admin', icon: <DashboardIcon/>},
        {name: 'Branch & Fran.', link: '/branch-admin', icon: <AccountTreeIcon/>},
        {name: 'Course', link: '/course-admin', icon: <BookIcon/>},
        {name: 'Questions', link: '/question-admin', icon: <QuestionAnswer/>},
        {name: 'Student', link: '/student-admin', icon: <GroupIcon/>},
        {name: 'Entry', link: '/payment-admin', icon: <PaymentIcon/>},
        {name: 'Report', link: '/report-admin', icon: <Assessment/>},
        {name: 'Gallery', link: '/gallery-admin', icon: <InsertPhotoIcon/>},
        {name: 'Offer', link: '/offer-admin', icon: <LocalOfferIcon/>},
        {name: 'Logout', link: `${url}/logout`, icon: <LogoutIcon/>}
    ]

    const [open, setOpen] = useState(false)

    return(
        <>
        <AppBar position='sticky' elevation={1} sx={{background: '#FFFFFF'}} >
            <Toolbar>
                <Typography fontSize={20} fontWeight='bold' color='black' letterSpacing={1} flexGrow={1} sx={{display: {xs: 'block', md: 'none'}}} >NEXUS COMPUTER</Typography>
                <Typography fontSize={20} fontWeight='bold' color='black' letterSpacing={1} flexGrow={1} sx={{display: {xs: 'none', md: 'block'}}} ml={29} >NEXUS COMPUTER</Typography>
                <IconButton onClick={() => history.push(`${path}/logout`)} ><PowerSettingsNew/></IconButton>
            </Toolbar>
        </AppBar>
        <Drawer variant='permanent' sx={{display: {xs: 'none', md: 'block'}}} PaperProps={{style: {background: '#ef6c00'}}} >
            <List>
                <ListItem>
                    <ListItemText>
                        <Typography align='center' color='white' variant='h5' fontWeight='bold' >ADMINISTRATOR</Typography>
                    </ListItemText>
                </ListItem><Divider/>
                { links.map((data, i) =>
                <ListItem key={i} >
                    <ListItemButton onClick={() => history.push(`${data.link}`)} >
                        <ListItemIcon sx={{color: 'white'}} >{data.icon}</ListItemIcon>
                        <ListItemText sx={{color: 'white'}} >{data.name}</ListItemText>
                    </ListItemButton>
                </ListItem>)}
            </List>
            <Button color='inherit' size='small' onClick={() => window.location.reload()} >UPDATE</Button>
        </Drawer>
        <Drawer open={open} variant='temporary' onClose={() => setOpen(false)} >
            <List>
                { links.map((data, i) =>
                <ListItem key={i} >
                    <ListItemButton onClick={() => history.push(`${data.link}`)} >
                        <ListItemIcon>{data.icon}</ListItemIcon>
                        <ListItemText>{data.name}</ListItemText>
                    </ListItemButton>
                </ListItem>)}
            </List>
            <Button color='inherit' size='small' onClick={() => window.location.reload()} >UPDATE</Button>
        </Drawer>
        <Box sx={{display: {xs: 'block', md: 'none'}}} >
            <Stack direction='row' spacing={3} justifyContent='space-around' sx={{position: 'fixed', bottom: 0, width: '100%', background: '#fafafa', zIndex: 100}} padding={0.5} >
                <IconButton onClick={() => history.push('/dashboard-admin')} ><DashboardIcon/></IconButton>
                <IconButton onClick={() => history.push('/student-admin')} ><GroupIcon/></IconButton>
                <IconButton onClick={() => history.push('/payment-admin')} ><PaymentIcon/></IconButton>
                <IconButton onClick={() => setOpen(true)} ><MoreVert/></IconButton>
            </Stack>
        </Box>
        <Route path={`${path}/logout`} component={Logout} />
        </>
    );

    function Logout(){

        const [loggingout, setLoggingout] = useState(false)
        const logout = () => {
            setLoggingout(true)
            var formData = new FormData()
            formData.append('logout', '')
            fetch(api, {
                method: 'post',
                body: formData
            }).then(res => res.json())
            .then(data => {
                setLoggingout(false)
                if(data.success){
                    // REDIRECT HERE
                    history.replace('/login-admin')
                }
            })
        }

        return(
            <Dialog open={true} fullWidth onClose={() => history.go(-1)}>
                <div className='container-fluid mt-5 mb-5'>
                    <div className='row p-3'>
                        <div className='col-12 text-center'>
                            <h1 className='fw-bold' >Do you want to logout?</h1>
                        </div>
                        <div className='col-12 text-center text-center mt-4'>
                            <Button color='warning' size='large' className='col-md-4 col-6' variant='contained' disabled={loggingout} onClick={() => logout()} >{loggingout ? <CircularProgress color='inherit' size={24} /> : 'Yes' }</Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }

}